const tags = {
  topDesc: [
    { name: '1girl', prob: 0.9893738627433777 },
    { name: 'solo', prob: 0.9647092819213867 },
    { name: 'purple_hair', prob: 0.8054952621459961 },
    { name: 'long_hair', prob: 0.6301497220993042 },
    { name: 'blue_eyes', prob: 0.48524075746536255 },
    { name: 'school_uniform', prob: 0.2432483732700348 },
    { name: 'shirt', prob: 0.2180299162864685 },
    { name: 'purple_eyes', prob: 0.1712031364440918 },
    { name: 'looking_at_viewer', prob: 0.1711733043193817 },
    { name: 'upper_body', prob: 0.14854374527931213 },
    { name: 'oekaki', prob: 0.11636656522750854 },
    { name: 'collarbone', prob: 0.09955704212188721 },
    { name: 'smile', prob: 0.08609086275100708 },
    { name: 'bangs', prob: 0.08267775177955627 },
    { name: 'face', prob: 0.0818156898021698 },
    { name: 'ribbon', prob: 0.07016932964324951 },
    { name: 'blue_hair', prob: 0.06386774778366089 },
    { name: 'dress', prob: 0.06199568510055542 },
    { name: 'white_shirt', prob: 0.060796767473220825 },
    { name: 'blush', prob: 0.058804482221603394 },
    { name: 't-shirt', prob: 0.05628931522369385 },
    { name: 'serafuku', prob: 0.054423391819000244 },
    { name: 'bare_shoulders', prob: 0.05393636226654053 },
    { name: 'off_shoulder', prob: 0.05202960968017578 },
    { name: 'bow', prob: 0.04937824606895447 },
    { name: 'twintails', prob: 0.043231040239334106 },
    { name: 'jewelry', prob: 0.04215317964553833 },
    { name: 'long_sleeves', prob: 0.039709120988845825 },
    { name: 'casual', prob: 0.03953194618225098 },
    { name: 'short_sleeves', prob: 0.039099931716918945 },
    { name: 'closed_mouth', prob: 0.03816154599189758 },
    { name: 'sketch', prob: 0.035831183195114136 },
    { name: 'bra', prob: 0.034649550914764404 },
    { name: 'sunset', prob: 0.033447086811065674 },
    { name: 'parted_lips', prob: 0.033423006534576416 },
    { name: 'skirt', prob: 0.03330010175704956 },
    { name: 'expressionless', prob: 0.032096296548843384 },
    { name: 'undressing', prob: 0.027622908353805542 },
    { name: 'lingerie', prob: 0.027516931295394897 },
    { name: 'black_eyes', prob: 0.027213752269744873 },
    { name: 'lips', prob: 0.026791274547576904 },
    { name: 'brown_hair', prob: 0.02672523260116577 },
    { name: 'black_hair', prob: 0.026495039463043213 },
    { name: 'clothes_writing', prob: 0.02589014172554016 },
    { name: 'frown', prob: 0.024601608514785767 },
    { name: 'sitting', prob: 0.023647814989089966 },
    { name: 'close-up', prob: 0.02334091067314148 },
    { name: 'hair_ribbon', prob: 0.02266305685043335 },
    { name: 'hair_between_eyes', prob: 0.022396475076675415 },
    { name: 'flat_chest', prob: 0.022363334894180298 },
    { name: 'pink_hair', prob: 0.02235180139541626 },
    { name: 'glasses', prob: 0.02187258005142212 },
    { name: 'raglan_sleeves', prob: 0.02164512872695923 },
    { name: 'eyebrows_visible_through_hair', prob: 0.021130502223968506 },
    { name: 'earrings', prob: 0.020623862743377686 },
    { name: 'mole', prob: 0.02026289701461792 },
    { name: 'gym_uniform', prob: 0.020196646451950073 },
    { name: 'red_hair', prob: 0.019464313983917236 },
    { name: 'light_smile', prob: 0.018545478582382202 },
    { name: 'short_hair', prob: 0.018315285444259644 },
    { name: 'mole_under_eye', prob: 0.018187373876571655 },
    { name: 'retro_artstyle', prob: 0.01790347695350647 },
    { name: 'wet', prob: 0.017800599336624146 },
    { name: 'pale_skin', prob: 0.017349600791931152 },
    { name: 'parody', prob: 0.016668379306793213 },
    { name: 'empty_eyes', prob: 0.01648065447807312 },
    { name: 'open_shirt', prob: 0.016097724437713623 },
    { name: 'choker', prob: 0.015973299741744995 },
    { name: 'sidelocks', prob: 0.015869110822677612 },
    { name: 'striped', prob: 0.01562434434890747 },
    { name: 'tank_top', prob: 0.015532314777374268 },
    { name: 'hairclip', prob: 0.015415370464324951 },
    { name: 'very_long_hair', prob: 0.015202999114990234 },
    { name: 'hair_ornament', prob: 0.015033215284347534 },
    { name: 'eyelashes', prob: 0.014811664819717407 },
    { name: 'from_above', prob: 0.014672547578811646 },
    { name: 'classroom', prob: 0.014539271593093872 },
    { name: 'arms_at_sides', prob: 0.014333248138427734 },
    { name: 'red_ribbon', prob: 0.01407235860824585 },
    { name: 'braid', prob: 0.013959169387817383 },
    { name: 'looking_up', prob: 0.01349109411239624 },
    { name: 'necklace', prob: 0.013471752405166626 },
    { name: 'strap_slip', prob: 0.013168126344680786 },
    { name: 'sweat', prob: 0.013117313385009766 },
    { name: 'green_eyes', prob: 0.012875288724899292 },
    { name: 'twin_braids', prob: 0.012609928846359253 },
    { name: 'bag', prob: 0.012587964534759521 },
    { name: 'looking_away', prob: 0.012566477060317993 },
    { name: 'sailor_collar', prob: 0.012455672025680542 },
    { name: 'open_clothes', prob: 0.011953085660934448 },
    { name: 'brown_eyes', prob: 0.011485457420349121 },
    { name: 'grey_eyes', prob: 0.01108279824256897 },
    { name: 'head_tilt', prob: 0.01107412576675415 },
    { name: 'no_bra', prob: 0.010967880487442017 },
    { name: 'blouse', prob: 0.010940134525299072 },
    { name: 'camisole', prob: 0.010831087827682495 },
    { name: 'see-through', prob: 0.010580211877822876 },
    { name: 'indoors', prob: 0.010445773601531982 },
    { name: ':o', prob: 0.009655624628067017 },
    { name: 'open_mouth', prob: 0.00952613353729248 },
  ],
  topChars: [
    { name: 'senjougahara_hitagi', prob: 0.52351975440979 },
    { name: 'matou_sakura', prob: 0.052112460136413574 },
    { name: 'busujima_saeko', prob: 0.044056057929992676 },
    { name: 'souryuu_asuka_langley', prob: 0.007879644632339478 },
    { name: 'teana_lanster', prob: 0.0071080029010772705 },
    { name: 'gokou_ruri', prob: 0.0062291622161865234 },
    { name: 'hoshizora_miyuki', prob: 0.0054207444190979 },
    { name: 'faris_scherwiz', prob: 0.004346311092376709 },
    { name: 'ayanami_rei', prob: 0.004181951284408569 },
    { name: 'nagato_yuki', prob: 0.0026373565196990967 },
    { name: 'hishikawa_rikka', prob: 0.0025270581245422363 },
    { name: 'shikinami_asuka_langley', prob: 0.0020911693572998047 },
    { name: 'patchouli_knowledge', prob: 0.001963019371032715 },
    { name: 'hanekawa_tsubasa', prob: 0.0017965435981750488 },
    { name: 'kisaragi_chihaya', prob: 0.0017161667346954346 },
    { name: 'yamada_aoi', prob: 0.0015429854393005371 },
    { name: 'kanbaru_suruga', prob: 0.001533418893814087 },
    { name: 'ichinose_shiki', prob: 0.001139312982559204 },
    { name: 'akemi_homura', prob: 0.0011112689971923828 },
    { name: 'furude_rika', prob: 0.0010620653629302979 },
    { name: 'katsuragi_misato', prob: 0.0010577738285064697 },
    { name: 'jessie_(pokemon)', prob: 0.00103074312210083 },
    { name: 'hino_akane_(smile_precure!)', prob: 0.0009311437606811523 },
    { name: 'aragaki_ayase', prob: 0.0008651018142700195 },
    { name: 'aoki_reika', prob: 0.0008352696895599365 },
    { name: 'tohsaka_rin', prob: 0.0007052421569824219 },
    { name: 'hino_rei', prob: 0.0006642639636993408 },
    { name: 'nakano_azusa', prob: 0.0006249845027923584 },
    { name: 'sonoda_umi', prob: 0.000612407922744751 },
    { name: 'sailor_mars', prob: 0.0005834102630615234 },
    { name: 'sheryl_nome', prob: 0.0005794167518615723 },
    { name: 'shirogane_naoto', prob: 0.000492781400680542 },
    { name: 'hiiragi_kagami', prob: 0.0004830360412597656 },
    { name: 'saotome_alto', prob: 0.0004202723503112793 },
    { name: 'kyon', prob: 0.000414431095123291 },
    { name: 'kawashima_ami', prob: 0.0003993213176727295 },
    { name: 'asakura_ryouko', prob: 0.0003885328769683838 },
    { name: 'madotsuki', prob: 0.00037616491317749023 },
    { name: 'kousaka_kirino', prob: 0.0003705918788909912 },
    { name: 'tsukikage_yuri', prob: 0.00037026405334472656 },
    { name: 'sakura_kyouko', prob: 0.0003604292869567871 },
    { name: 'gasai_yuno', prob: 0.00035649538040161133 },
    { name: 'tohno_akiha', prob: 0.00032767653465270996 },
    { name: 'shimazu_yoshino', prob: 0.0003122091293334961 },
    { name: 'ikari_shinji', prob: 0.00028073787689208984 },
    { name: 'hatsune_miku', prob: 0.00027701258659362793 },
    { name: 'megurine_luka', prob: 0.0002499520778656006 },
    { name: 'makinami_mari_illustrious', prob: 0.0002453923225402832 },
    { name: 'ogasawara_sachiko', prob: 0.0002383589744567871 },
    { name: 'akagi_(kantai_collection)', prob: 0.0002283155918121338 },
    { name: 'kuchiki_rukia', prob: 0.00022205710411071777 },
    { name: 'hakurei_reimu', prob: 0.00021967291831970215 },
    { name: 'stocking_(psg)', prob: 0.00021311640739440918 },
    { name: 'akiyama_mio', prob: 0.00020837783813476562 },
    { name: 'princess_of_moonbrook', prob: 0.00020506978034973145 },
    { name: 'kiryuuin_satsuki', prob: 0.0001952648162841797 },
    { name: 'gertrud_barkhorn', prob: 0.00018164515495300293 },
    { name: 'hanyuu', prob: 0.00017690658569335938 },
    { name: 'asahina_mikuru', prob: 0.00017145276069641113 },
    { name: 'hijiri_byakuren', prob: 0.00017079710960388184 },
    { name: 'kousaka_tamaki', prob: 0.00016438961029052734 },
    { name: 'kaname_madoka', prob: 0.00015982985496520996 },
    { name: 'izumi_konata', prob: 0.00015366077423095703 },
    { name: 'kusanagi_motoko', prob: 0.00015231966972351074 },
    { name: 'artoria_pendragon_(all)', prob: 0.00014603137969970703 },
    { name: 'kirisame_marisa', prob: 0.00013947486877441406 },
    { name: 'hong_meiling', prob: 0.0001310110092163086 },
    { name: 'shirayuki_hime', prob: 0.00013014674186706543 },
    { name: 'emiya_shirou', prob: 0.00012731552124023438 },
    { name: 'matoi_ryuuko', prob: 0.00012162327766418457 },
    { name: 'hachikuji_mayoi', prob: 0.00011754035949707031 },
    { name: 'yuri_(angel_beats!)', prob: 0.00011745095252990723 },
    { name: 'houraisan_kaguya', prob: 0.00011342763900756836 },
    { name: 'hyuuga_hinata', prob: 0.00011032819747924805 },
    { name: 'yoko_littner', prob: 0.00011020898818969727 },
    { name: 'rider', prob: 0.00010496377944946289 },
    { name: 'houjou_hibiki', prob: 0.00009816884994506836 },
    { name: 'makise_kurisu', prob: 0.00009495019912719727 },
    { name: 'akatsuki_(kantai_collection)', prob: 0.00009003281593322754 },
    { name: 'amagi_yukiko', prob: 0.00008824467658996582 },
    { name: 'hirasawa_yui', prob: 0.00008362531661987305 },
    { name: 'dawn_(pokemon)', prob: 0.00007990002632141113 },
    { name: 'haramura_nodoka', prob: 0.00007978081703186035 },
    { name: 'kenzaki_makoto', prob: 0.00007909536361694336 },
    { name: 'kurumi_erika', prob: 0.00007539987564086914 },
    { name: 'yakumo_yukari', prob: 0.00007030367851257324 },
    { name: 'takamachi_nanoha', prob: 0.0000693202018737793 },
    { name: 'aida_mana', prob: 0.00006836652755737305 },
    { name: 'ultimate_madoka', prob: 0.00006529688835144043 },
    { name: 'saber', prob: 0.000059485435485839844 },
    { name: 'miki_sayaka', prob: 0.00005760788917541504 },
    { name: 'kyubey', prob: 0.000054776668548583984 },
    { name: 'izayoi_sakuya', prob: 0.000053822994232177734 },
    { name: 'izayoi_liko', prob: 0.00005272030830383301 },
    { name: 'kuma_(persona_4)', prob: 0.000051975250244140625 },
    { name: 'remilia_scarlet', prob: 0.000050574541091918945 },
    { name: 'kotobuki_tsumugi', prob: 0.000050127506256103516 },
    { name: 'suigintou', prob: 0.000049591064453125 },
    { name: 'aozaki_aoko', prob: 0.000048667192459106445 },
    { name: 'fujiwara_no_mokou', prob: 0.000046193599700927734 },
  ],
  rating: [
    { name: 'safe', prob: 0.8854891061782837 },
    { name: 'questionable', prob: 0.12838685512542725 },
    { name: 'explicit', prob: 0.005569428205490112 },
  ],
}

export default tags
